const ALL_ADMIN_PERMISSIONS = ["DASHBOARD", "CONTROL", "OPERATIONS", "PAYMENTS", "HISTORY"];

/** Mirrors Backend/apps/users/services.ROLE_DEFAULT_ADMIN_MODULES */
const ROLE_DEFAULT_ADMIN_MODULES = {
  ADMIN: ALL_ADMIN_PERMISSIONS,
  SUPER_ADMIN: ALL_ADMIN_PERMISSIONS,
  ACCOUNTANT: ["DASHBOARD", "OPERATIONS", "PAYMENTS", "HISTORY"],
  MARKETING: ["DASHBOARD"],
};

function readEffectivePermissions(user) {
  const role = String(user?.role || "").toUpperCase();
  if (role === "SUPER_ADMIN") {
    return [...ALL_ADMIN_PERMISSIONS];
  }
  const fromApi = user?.effective_admin_permissions;
  if (Array.isArray(fromApi) && fromApi.length > 0) {
    return fromApi.map((k) => String(k || "").toUpperCase());
  }
  const configured = user?.admin_permissions;
  if (Array.isArray(configured)) {
    const normalized = configured
      .map((k) => String(k || "").toUpperCase())
      .filter((k) => ALL_ADMIN_PERMISSIONS.includes(k));
    if (normalized.length > 0) {
      return normalized;
    }
  }
  return ROLE_DEFAULT_ADMIN_MODULES[role] ? [...ROLE_DEFAULT_ADMIN_MODULES[role]] : [];
}

export function hasAdminModuleAccess(user, moduleKey) {
  if (!moduleKey) return true;
  const role = String(user?.role || "").toUpperCase();
  if (role === "SUPER_ADMIN") return true;
  const key = String(moduleKey || "").toUpperCase();
  const perms = readEffectivePermissions(user);
  return perms.includes(key);
}

export function getAllowedAdminModules(user) {
  const role = String(user?.role || "").toUpperCase();
  if (role === "SUPER_ADMIN") return [...ALL_ADMIN_PERMISSIONS];
  const perms = readEffectivePermissions(user);
  return ALL_ADMIN_PERMISSIONS.filter((key) => perms.includes(key));
}

export { ALL_ADMIN_PERMISSIONS, ROLE_DEFAULT_ADMIN_MODULES };
